import React from "react";
import { Badge, Skeleton } from "@chakra-ui/react";

export const getOrderStatusBadge = (order) => {
  let color;
  switch (order.statusId) {
    case 1:
      color = "green";
      break;
    case 2:
      color = "blue";
      break;
    case 3:
      color = "red";
      break;
    case 4:
      color = "yellow";
      break;
    case 5:
      color = "gray";
      break;
    default:
      break;
  }
  return (
    <Badge colorScheme={color} fontSize="0.9em">
      {order.status}
    </Badge>
  );
};

export const createSkeleton = (columns) => {
  let skeleton = [];
  for (let index = 0; index < columns; index++) {
    skeleton.push({ item: <Skeleton height="1rem" /> });
  }
  return skeleton;
};
